var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 49.5V56.25C27.4167 57.1186 26.7019 57.8333 25.8333 57.8333C24.9648 57.8333 24.25 57.1186 24.25 56.25V49.5H27.4167Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 49.5V56.25C37.75 57.1186 37.0352 57.8333 36.1667 57.8333C35.2981 57.8333 34.5833 57.1186 34.5833 56.25V49.5H37.75Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9167 28.4167V41.3333C42.9167 43.6227 41.0394 45.5 38.75 45.5H23.25C20.9606 45.5 19.0833 43.6227 19.0833 41.3333V28.4167C19.0833 26.1273 20.9606 24.25 23.25 24.25H38.75C41.0394 24.25 42.9167 26.1273 42.9167 28.4167Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 28.4166V38.75C11.9167 39.6185 11.2019 40.3333 10.3333 40.3333C9.46478 40.3333 8.75 39.6185 8.75 38.75V28.4166C8.75 27.5481 9.46478 26.8333 10.3333 26.8333C11.2019 26.8333 11.9167 27.5481 11.9167 28.4166Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 28.4166V38.75C53.25 39.6185 52.5352 40.3333 51.6667 40.3333C50.7981 40.3333 50.0833 39.6185 50.0833 38.75V28.4166C50.0833 27.5481 50.7981 26.8333 51.6667 26.8333C52.5352 26.8333 53.25 27.5481 53.25 28.4166Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 15.5C40.3333 17.2211 38.9211 18.6334 37.2001 18.6334H24.7999C23.0789 18.6334 21.6667 17.2211 21.6667 15.5C21.6667 10.3431 25.8431 6.16669 31 6.16669C36.1569 6.16669 40.3333 10.3431 40.3333 15.5Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.bb5c1996bb3761fbe3f1957d4931e0f8.svg";
export { ForwardRef as ReactComponent };